import React from 'react';
import PropTypes from 'prop-types';
import {Subheader, Paper} from 'material-ui';
import style from '../../../../styles/styles';
import Info from "../../../common/Info/Info";

const Timestamp = require('react-timestamp');

class TypeInfo extends React.Component {
    static propTypes = {
        type: PropTypes.object.isRequired
    };

    render() {
        return (
            <Paper>
                <Subheader style={style.subHeader}>Information</Subheader>
                <div style={style.paper}>
                    <Info
                        title="Id"
                        content={this.props.type.id}
                    />
                    <Info
                        title="Name"
                        content={this.props.type.name}
                    />
                    <Info
                        title="Tag"
                        content={this.props.type.tag}
                    />
                    <Info
                        title="Color"
                        content={this.props.type.color}
                    />
                    <Info
                        title="Display order"
                        content={this.props.type.display_order}
                    />
                    <Info
                        title="Created at"
                        content={<Timestamp time={this.props.type.created_at} format='full' twentyFourHour/>}
                    />
                    <Info
                        title="Updated at"
                        content={(
                            this.props.type.updated_at &&
                            <Timestamp time={this.props.type.updated_at} format='full' twentyFourHour/>
                        ) || 'Has never been updated'}
                        divider={false}
                    />
                </div>
            </Paper>
        )
    };
}

export default TypeInfo;



// WEBPACK FOOTER //
// src/components/type/TypeFull/TypeInfo/TypeInfo.js